import PackageService from "../../services/PackageService";
import AxiosErrorHandler from "../../helpers/AxiosErrorHandler";
import router from "../../router";
import ProjectsService from "../../services/ProjectsService";
export const namespaced = true;
import ItemService from "../../services/ItemService";

const initialState = {
  items: [],
  selectedItem: null,
};

export const state = {
  items: [],
  selectedItem: null,
};

export const mutations = {
  SET_ITEMS(state, recs) {
    state.items = recs;
  },
  SET_SELECTED_ITEM(state, rec) {
    state.selectedItem = rec;
  },
  RESET_STORE(state) {
    Object.assign(state, initialState);
  },
};

export const actions = {
  fetchItems: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return PackageService.getPackageItems(context.rootGetters['ProjectPackagesStore/getSelectedPackageId']).then(
      (r) => {
        context.commit('SET_ITEMS', r.data)
        context.commit("SET_LOADING_STATUS", "idle", { root: true });
      },
      (e) => {
        context.commit("SET_ITEMS", null);
        context.commit("SET_LOADING_STATUS", "idle", { root: true });
        AxiosErrorHandler.handler(e, context, router);
      }
    );
  },
  setSelectedItem: function(context, value) {
    context.commit("SET_LOADING_STATUS", "loading", { root: true });
    return ItemService.getPackageItemsById(value).then(
      (r) => {
        context.commit("SET_SELECTED_ITEM", r.data);
        context.dispatch(
          "BreadcrumbsStore/add",
          {
            text: "ITEM",
            name: r.data.name,
          },
          { root: true }
        );
        context.commit("SET_LOADING_STATUS", "idle", { root: true });
      },
      (e) => {
        context.commit("SET_SELECTED_ITEM", null);
        context.commit("SET_LOADING_STATUS", "idle", { root: true });
        AxiosErrorHandler.handler(e, context, router);
      }
    );
  },
  addItem: async function(context, value) {
    context.commit("SET_LOADING_STATUS", "loading", { root: true });

    await ItemService.createPackageItem(value);
    context.dispatch("fetchItems");
  },

  deleteItem: async function(context, value) {
    context.commit("SET_LOADING_STATUS", "loading", { root: true });

    try {
      await ItemService.deletePackageItem(value);
    } catch (error) {
      context.commit("SET_LOADING_STATUS", "idle", { root: true });
      AxiosErrorHandler.handler(error, context, router);
      throw error;
    }
  },
  updateItem: async function(context, value) {
    context.commit("SET_LOADING_STATUS", "loading", { root: true });
    return ItemService.updatePackageItem(value).then(
      (res) => {
        context.commit("SET_SELECTED_ITEM", res.data);
        context.dispatch(
          "BreadcrumbsStore/update",
          {
            text: "ITEM",
            name: res.data.name,
          },
          { root: true }
        );

        context.commit("SET_LOADING_STATUS", "idle", { root: true });
        context.dispatch("fetchItems");
      },
      (e) => {
        context.commit("SET_LOADING_STATUS", "idle", { root: true });
        AxiosErrorHandler.handler(e, context, router);
      }
    );
    
  },
  resetStore: async function(context) {
    context.commit("SET_LOADING_STATUS", "loading", { root: true });
    context.commit("RESET_STORE");
    context.commit("SET_LOADING_STATUS", "idle", { root: true });
  },
};

export const getters = {
  getSelectedItemId: (state) => {
    return state.selectedItem ? state.selectedItem.id : 0;
  },
};
